<template>
  <div class="admin-form">
      <label class="tw-w-32 select select--small" v-if="type == 'monthly'">
        <select v-model="selectedMonthInput" class="financial-select">
          <option v-for="month in months" :value="month.value" :key="month.value">{{ month.name }}</option>
        </select>
        <i class="arrow"></i>
      </label>

     <label class="tw-w-20 select select--small" v-if="type !== 'all'">
       <select v-model="selectedYearInput" class="financial-select">
          <option v-for="year in years" :key="year">{{ year }}</option>
        </select>
        <i class="arrow"></i>
     </label>

    <label class="tw-w-32 select select--small">
      <select v-model="typeInput" class="financial-select">
        <option value="monthly">Mensal</option>
        <option value="yearly">Anual</option>
        <option value="all">Todo período</option>
      </select>
      <i class="arrow"></i>
    </label>
  </div>
</template>

<script>
export default {
  props: ["selectedYear", "selectedMonth", "type", "companyCreatedAt"],
  data() {
    return {
      months: [
        {value: 1, name: "Janeiro"},
        {value: 2, name: "Fevereiro"},
        {value: 3, name: "Março"},
        {value: 4, name: "Abril"},
        {value: 5, name: "Maio"},
        {value: 6, name: "Junho"},
        {value: 7, name: "Julho"},
        {value: 8, name: "Agosto"},
        {value: 9, name: "Setembro"},
        {value: 10, name: "Outubro"},
        {value: 11, name: "Novembro"},
        {value: 12, name: "Dezembro"}
      ],

      years: [],
    };
  },
  mounted() {
    let years = [];
    for (
      let i = moment(this.companyCreatedAt).year();
      i <= moment().year();
      i++
    ) {
      years.push(i);
    }
    this.years = years;
  },
  computed: {
    selectedMonthInput: {
      get() {
        return this.selectedMonth;
      },
      set(val) {
        this.$emit('selected-month', val);
      }
    },
    selectedYearInput: {
      get() {
        return this.selectedYear;
      },
      set(val) {
        this.$emit('selected-year', val);
      }
    },
    typeInput: {
      get() {
        return this.type;
      },
      set(val) {
        this.$emit('type', val);
      }
    }
  }
};
</script>
